
import axios from 'axios';
import DASHBOARD from '../dashboard';
import store from '../store';
import { getErrorMessage } from '../services/errorLog';
import { API_DEFAULT_TIMEOUT } from '../constants/api';

const UNAUTHORIZED = 401;

DASHBOARD.namespace('DASHBOARD.Services.Online');

DASHBOARD.Services.Online = (function online() {
    /**
     * public API -- constructor
     */
    const fnConstructor = function fn() {
        // nothing to do
    };

    /**
     * public API -- prototype
     * @type {Object}
     */
    fnConstructor.prototype = {
        constructor: DASHBOARD.Services.Online,
        version: '1.0',

        /**
         * Show a unauthirized message
         * @param {[type]} error [description]
         */
        UnauthorizedError(error) {
            if (error.response.status === 401) {
                alert('U bent niet geauthoriseerd voor deze actie.');
            }
        },

        /**
         * Get an axios instance
         * @return {[type]} [description]
         */
        axiosInstance(endpoint, timeout) {
            let token = store.state.accessToken;
            if (store.state.requiresAuthentication && !token) {
                throw new Error('no token found');
            }
            const headers =  token !== 'noauth' ? { Authorization: `Bearer ${token}`, } : undefined;

            const instance = axios.create({
                baseURL: endpoint,
                timeout,
                headers
            });
            instance.interceptors.response.use(
                response => response,
                async error => {
                    const originalRequest = error.config;
                    const { status } = error.response;
                    if (status === UNAUTHORIZED && !originalRequest._retry) {
                        originalRequest._retry = true;
                        await store.dispatch('refreshLoginToken');
                        token = store.state.accessToken;
                        originalRequest.headers['Authorization'] = `Bearer ${token}`;
                        return instance(originalRequest);
                    }
                    return Promise.reject(error);
                }
            );
            return instance;
        },

        /**
         * Api Get call
         * @param  {string} url api url
         * @param  {object} params querystring
         * @param  {string} endpoint api or webapi endpoint
         * @param  {number} timeout custom request timeout
         * @return {*}     [description]
         */
        async axiosGet(url, params, endpoint, timeout = API_DEFAULT_TIMEOUT, retryCount = 0) {
            try {
                const axionInstance = this.axiosInstance(endpoint, timeout);
                return await axionInstance.get(url, params);
            } catch (error) {
                throw getErrorMessage(error);
            }
        },

        /**
         * Api Post call
         * @param  {string} url api url
         * @param  {object} data data to post
         * @param  {string} endpoint api or webapi endpoint
         * @param  {number} timeout custom request timeout
         * @return {*}     [description]
         */
        async axiosPost(url, data, endpoint, timeout = API_DEFAULT_TIMEOUT, config = null) {
            try {
                const axionInstance = this.axiosInstance(endpoint, timeout);
                return await axionInstance.post(url, data, config);
            } catch (error) {
                throw getErrorMessage(error);
            }
        },

        /**
         * Api Put call
         * @param  {string} url api url
         * @param  {object} data data to post
         * @param  {string} endpoint api or webapi endpoint
         * @param  {number} timeout custom request timeout, defaults to 10000 ms
         * @return {*}     [description]
         */
        async axiosPut(url, data, endpoint, timeout = 10000, config = null) {
            try {
                const axionInstance = this.axiosInstance(endpoint, timeout);
                return await axionInstance.put(url, data, config);
            } catch (error) {
                throw getErrorMessage(error);
            }
        },

        /**
         * Api Delete call
         * @param  {string} url api url
         * @param  {object} data data to post
         * @param  {string} endpoint api or webapi endpoint
         * @param  {number} timeout custom request timeout
         * @return {*}     [description]
         */
        async axiosDelete(url, data, endpoint, timeout = API_DEFAULT_TIMEOUT) {
            try {
                const axionInstance = this.axiosInstance(endpoint, timeout);
                return await axionInstance.delete(url, data);
            } catch (error) {
                throw getErrorMessage(error);
            }
        },
    };

    // return the constructor
    return fnConstructor;
}());

export default DASHBOARD.Services.Online;
